import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "type" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("edit")) {
      if (this.typeTarget.value == 1) {
        document.getElementById("operationAreaBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("operationAreaBlock").classList.add("is-display-none")
      }
      if (this.typeTarget.value == 0) {
        document.getElementById("financeContactEmailBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("financeContactEmailBlock").classList.add("is-display-none")
      }
    }

    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update") || document.body.getAttribute("data-action").includes("edit_account") || document.body.getAttribute("data-action").includes("update_account")) {
      var cleave = new Cleave(".input-vat-number", {
        delimiters: [".", ".", "/", "-"],
        blocks: [2, 3, 3, 4, 2],
      })

      var cleave = new Cleave(".input-phone-number", {
        phone: true,
        phoneRegionCode: "br"
      })
    }
  }

  changeOperationArea(event) {
    if (event.currentTarget.value == 1) {
      document.getElementById("operationAreaBlock").classList.remove("is-display-none")
    } else {
      document.getElementById("operationAreaBlock").classList.add("is-display-none")
    }
    if (event.currentTarget.value == 0) {
      document.getElementById("financeContactEmailBlock").classList.remove("is-display-none")
    } else {
      document.getElementById("financeContactEmailBlock").classList.add("is-display-none")
    }
  }

  search() {
    fetch("/hub/empresas/buscar-empresa/", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        company_name: event.currentTarget.value
      })
    }
    ).then(res => {
      return res.text()
    }).then(data => {
      document.getElementById("companyPartial").innerHTML = data
    })
    // url: "/funcionarios/socios/pessoa-juridica/buscar-socio"
    // type: "GET"
    // data:
    //   enterprise_partner:
    //     text: $("#enterprisePartnerLegalNameInEmployees").val()
    // success: (resp) ->
    //   $("#listEnterprisePartners").html resp
    //   $("a[href='#preventDefault']").click (event) ->
    //     event.preventDefault()
    //   $(".panel-list-body div.action").click (el) ->
    //     openList el
  }
}
